import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import classes from './PublicSignInPrompt.module.css';

//The sign-in offer on a public agenda page (publicView.js). Omerson 10/20/2026: a visitor
//without a CWU sign-in sees the agenda, with "some sort of popup ... Do you have an account
//then sign in". Closing it ("Browse the agenda") leaves the agenda with every tile greyed
//out; a click on a tile goes to the tickets link. A slim top bar (logo + Sign in) stands in for
//the site menu bar the public view does not have: the page's sticky day tabs sit 60px down for
//that bar, so without it the sessions showed through the gap above them (Omerson 10/20/2026).

//The site menu bar's own logo (the "Header" page), dark on white.
const LOGO =
  'https://elasticbeanstalk-us-east-2-783675859554.s3.amazonaws.com/CWU%20Black.png';

const DISMISSED_KEY = 'cwuPublicSignInDismissed';

//`<html data-cwu-public>` while the public view is on screen, so a page's own CSS can word things
//for a visitor who is not signed in (Omerson 10/20/2026: say "Not included with your ticket" only
//to a signed-in member; the BSM 2026 page CSS reads it as `:root[data-cwu-public] & ...`).
export const PUBLIC_VIEW_ATTRIBUTE = 'data-cwu-public';

const readDismissed = () => {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === '1';
  } catch (error) {
    return false;
  }
};

//Back to the same page and row after signing in (App.tsx enterCWU reads beforeLogin).
export const signInHere = () => {
  try {
    window.localStorage.setItem(
      'beforeLogin',
      window.location.pathname + window.location.hash
    );
  } catch (error) {
    //without storage the visitor lands on the home page after signing in
  }
  window.location.assign('/login');
};

const PublicSignInPrompt = () => {
  const [open, setOpen] = useState(!readDismissed());

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute(PUBLIC_VIEW_ATTRIBUTE, '');
    return () => root.removeAttribute(PUBLIC_VIEW_ATTRIBUTE);
  }, []);

  const browse = () => {
    setOpen(false);
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, '1');
    } catch (error) {
      //the popup shows again on the next page load; harmless
    }
  };

  return (
    <>
      <header className={classes.bar}>
        <img className={classes.logo} src={LOGO} alt='Club Wealth University' />
        <button type='button' className={classes.pill} onClick={signInHere}>
          Sign in
        </button>
      </header>
      <Modal
        open={open}
        onCancel={browse}
        footer={null}
        centered
        width={440}
        className={classes.modal}
      >
        <h2 className={classes.title}>
          Already have a Club Wealth University account?
        </h2>
        <p className={classes.text}>
          Sign in to see which sessions your ticket includes and to join them.
          You can also browse the full agenda without an account.
        </p>
        <div className={classes.actions}>
          <button
            type='button'
            className={classes.primary}
            onClick={signInHere}
          >
            Sign in
          </button>
          <button type='button' className={classes.secondary} onClick={browse}>
            Browse the agenda
          </button>
        </div>
      </Modal>
    </>
  );
};

export default PublicSignInPrompt;
